(function () {
  const SELECTOR = '[data-ru-agrupacion-carousel]';
  const DESKTOP_QUERY = '(min-width: 720px)';
  const DESKTOP_SCROLL_MIN = 5;
  const DRAG_THRESHOLD = 8;

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function shouldScroll(node) {
    const itemCount = parseInt(node.dataset.itemCount, 10) || 0;
    if (isDesktop()) return itemCount > DESKTOP_SCROLL_MIN;
    return true;
  }

  function setupDragScroll(node) {
    if (node.ruAgrupacionDragReady) return;
    node.ruAgrupacionDragReady = true;

    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let dragDistance = 0;

    node.addEventListener('mousedown', function (e) {
      if (!isDesktop() || e.button !== 0) return;

      isDown = true;
      isDragging = false;
      dragDistance = 0;
      startX = e.pageX;
      scrollLeft = node.scrollLeft;
    });

    node.addEventListener('mouseleave', function () {
      isDown = false;
      isDragging = false;
      node.classList.remove('is-dragging');
    });

    node.addEventListener('mouseup', function () {
      isDown = false;
      isDragging = false;
      node.classList.remove('is-dragging');
    });

    node.addEventListener('mousemove', function (e) {
      if (!isDown) return;

      const walk = e.pageX - startX;
      dragDistance = Math.max(dragDistance, Math.abs(walk));

      if (!isDragging && dragDistance <= DRAG_THRESHOLD) return;

      isDragging = true;
      node.classList.add('is-dragging');
      e.preventDefault();
      node.scrollLeft = scrollLeft - walk;
    });

    node.querySelectorAll('.ru-agrupacion__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (dragDistance > DRAG_THRESHOLD) {
          e.preventDefault();
        }
        dragDistance = 0;
      });
    });
  }

  function initCarousel(node) {
    if (!node) return;

    const scrollable = shouldScroll(node);

    if (scrollable) {
      node.classList.remove('ru-agrupacion__carousel--static');
      node.classList.add('ru-agrupacion__carousel--scrollable');
      node.scrollLeft = 0;
      setupDragScroll(node);
    } else {
      node.classList.remove('ru-agrupacion__carousel--scrollable', 'is-dragging');
      node.classList.add('ru-agrupacion__carousel--static');
    }

    node.dataset.ruAgrupacionReady = scrollable ? 'scrollable' : 'static';
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  window.matchMedia(DESKTOP_QUERY).addEventListener('change', initAll);
})();
